export default __webpack_public_path__ + "images/Asteroid.3-27d42c393062176f33869897d024e0b5.png";